import { useState } from "react";
import { IoFastFood } from "react-icons/io5";

const ImageLoader = ({ src, alt = "", ...props }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const showPlaceholder = !src || error;

  return (
    <div className="relative w-full h-full">
      {loading && !showPlaceholder && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-md" />
      )}

      {showPlaceholder && (
        <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-md">
          <IoFastFood className="text-gray-300 w-12 h-12 " />
        </div>
      )}

      {!showPlaceholder && (
        <img
          src={src}
          alt={alt}
          className={`w-full h-full object-cover transition-transform duration-500
            ${loading ? "opacity-0" : "opacity-100"} 
            group-hover:scale-105
          `}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError(true);
          }}
          {...props}
        />
      )}
    </div>
  );
};

export default ImageLoader;
